var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 101,
    viewBox: "0 0 107 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11496",
    "data-name": "Group 11496",
    transform: "translate(-2128 -1867)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15595",
    "data-name": "Rectangle 15595",
    width: 107,
    height: 101,
    rx: 29,
    transform: "translate(2128 1867)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11494",
    "data-name": "Group 11494",
    transform: "translate(16.693 -3.23)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ins-icon-secondary",
    id: "Path_7719",
    "data-name": "Path 7719",
    d: "M1005.916,372.266a39.816,39.816,0,0,1-1.013,3.995c-1.981,5.468-5.988,8.618-11.62,9.651a14.853,14.853,0,0,1-17.062-11.949,16.843,16.843,0,0,1,1.38-10.45,10.661,10.661,0,0,1,2.21-2.922,2.553,2.553,0,0,1,4.262,1.11c.224.607.474,1.2.715,1.815.5-1.8.883-3.561,1.474-5.247a22.841,22.841,0,0,1,6.305-9.455,8.042,8.042,0,0,1,1.343-.815h1.022a3.1,3.1,0,0,1,2.165,2.566,12.055,12.055,0,0,0,1.06,3.313c1.171,2.158,2.548,4.2,3.8,6.321a54.219,54.219,0,0,1,2.82,5.114,27.02,27.02,0,0,1,1.143,4.015Zm-24.4-9.639-.2-.081a16.446,16.446,0,0,0-1.295,2.085,14.63,14.63,0,0,0-1.129,8.792,12.22,12.22,0,0,0,21.521,5.418,12.48,12.48,0,0,0,1.073-14.181c-1.183-2.015-2.5-3.95-3.766-5.918a22.509,22.509,0,0,1-3.105-6.606c-.113-.448-.208-.9-.312-1.351l-.215-.156a3.386,3.386,0,0,1-.368.6,21.539,21.539,0,0,0-6.194,15.33,1.41,1.41,0,0,1-2.41,1.2A9.772,9.772,0,0,1,981.516,362.627Z",
    transform: "translate(1191.574 1568.859)",
    fill: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ins-icon-primary",
    id: "Path_7713",
    "data-name": "Path 7713",
    d: "M28.871,60.781H15.2A6.084,6.084,0,0,1,9.117,54.7V33.429H3.039A3.009,3.009,0,0,1,0,30.39a3.071,3.071,0,0,1,.991-2.255L30.877.406a1.519,1.519,0,0,1,2.067,0l9.6,8.9V4.557a1.52,1.52,0,0,1,1.52-1.52h9.117a1.52,1.52,0,0,1,1.52,1.52V20.58l7.722,7.175a1.519,1.519,0,1,1-2.07,2.225L52.15,22.351a1.5,1.5,0,0,1-.486-1.109V6.077H45.586v6.716a1.52,1.52,0,0,1-2.553,1.112L31.91,3.591,3.039,30.378l7.6.012a1.52,1.52,0,0,1,1.52,1.52V54.7A3.042,3.042,0,0,0,15.2,57.742H28.871a1.52,1.52,0,0,1,0,3.039Z",
    transform: "translate(2132.307 1887.229)",
    fill: "#8f8f8f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.d73739811793f6b8ec1b29a9a67150e7.svg";
export { ForwardRef as ReactComponent };